import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import type { Asset, Assignment } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { StoreTypename } from 'types';
import GET_ASSIGNMENTS from '../../queries/assignments/get-assignments-query';

export type AssignmentsState = {
  assignments: any;
  assignmentSelectSound: Asset | undefined;
  activitySelectSound: Asset | undefined;
  error: ApolloError | undefined;
  isLoading: boolean;
};
export type AssignmentsDispatch = undefined;
export type Assignments = [AssignmentsState, AssignmentsDispatch];

export type AssignmentList = {
  assignments: [Assignment] | undefined;
  instructions: {
    assignmentSelection: Asset;
    activitySelection: Asset;
  };
};

export const Assignments = (): { __typename: string } => ({
  __typename: StoreTypename.ASSIGNMENTS,
});

const useAssignmentsStore = (character?: string): Assignments => {
  const { data, loading, error }: QueryResult<{ assignmentList: AssignmentList }> = useQuery(
    GET_ASSIGNMENTS,
    {
      fetchPolicy: 'no-cache',
      variables: {
        where: { character: character ? { character: [character] } : null },
      },
    }
  );

  return [
    {
      assignmentSelectSound: data?.assignmentList?.instructions?.assignmentSelection,
      activitySelectSound: data?.assignmentList?.instructions?.activitySelection,
      assignments: data?.assignmentList?.assignments || null,
      error,
      isLoading: loading,
    },
    undefined,
  ];
};

export default useAssignmentsStore;
